// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_xXw","cls2":"common-cls2_W9z common-cls1_xXw","altLook":"common-altLook_JfR"};